export default __webpack_public_path__ + "static/media/EconomicsGoodsService_05.5774be9d.png";